import superagentDefaults from 'superagent-defaults'

const http_agent = superagentDefaults()

export default http_agent
